import { joinURL } from "ufo";
import type { ProviderGetImage } from "@nuxt/image";
import type { ImageModifiers } from "~/components/blocks/media";

const extractMediaId = (path: string): string | undefined => {
  const normalizedPath = path.replace(/\\/g, "/");

  const uuidMatch = normalizedPath.match(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i
  );

  return uuidMatch?.[0];
};

// Extract numeric value from strings like "100px" or return undefined if invalid
function parseNumeric(value: any): number | undefined {
  if (typeof value === "number" && !isNaN(value)) return value;

  if (typeof value === "string") {
    const match = value.match(/^(\d+(?:\.\d+)?)/);
    if (match) return Number(match[1]);
  }

  return undefined;
}

function toMediaLibraryParams(modifiers: ImageModifiers = {}): string {
  const params = new URLSearchParams();

  const width = parseNumeric(modifiers.width);
  const height = parseNumeric(modifiers.height);

  if (!width && !height) {
    params.set("w", "400"); // fallback default width
  } else {
    if (width) params.set("w", width.toString());
    if (height) params.set("h", height.toString());
  }

  if (modifiers.fit) {
    params.set("fit", String(modifiers.fit));
  }
  if (modifiers.format) {
    params.set("convert", String(modifiers.format));
  } else {
    params.set("convert", "webp");
  }
  if (modifiers.quality) {
    params.set("q", String(modifiers.quality));
  }
  if (modifiers.blur) {
    params.set("blur", String(modifiers.blur));
  }
  if (modifiers.background) {
    params.set("bg", String(modifiers.background));
  }
  if (modifiers.crop) {
    params.set("crop", String(modifiers.crop));
  }
  if (modifiers.fill) {
    params.set("fill", String(modifiers.fill));
  }

  return params.toString();
}

export const getImage: ProviderGetImage = (
  src,
  { modifiers = {}, baseURL }
) => {
  const id = extractMediaId(src);

  console.log(">>> modifiers", modifiers);

  if (id) {
    const operations = toMediaLibraryParams(modifiers as any);

    return {
      url: joinURL(baseURL, "img", id + (operations ? `?${operations}` : "")),
    };
  }

  return {
    url: src,
  };
};
